// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2270936c","36":"ae39aa79","75":"24aed20d","161":"6686a8f0","284":"3ebfda39","401":"226f3a96","436":"55c0cfd2","666":"86a59150","749":"d5717cd7","787":"ed87aa52","879":"56a57e24","882":"8244416b","945":"05263119"}[chunkId] + ".chunk.js";
};